// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import {jsonPost} from './util/http'
import 'element-ui/lib/theme-chalk/index.css'
import '../theme/index.css'
import ViewUI from 'view-design'
import 'view-design/dist/styles/iview.css'
import '../iview-theme/index.less'
import md5 from 'js-md5'
import VueCookies from 'vue-cookies'
import store from './store'

Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.use(ViewUI)
Vue.use(VueCookies)

Vue.prototype.$md5 = md5
Vue.prototype.$post = jsonPost

Vue.prototype.$loadShowing = function (text) {
  if (text === undefined || text === '') {
    text = '加载中'
  }
  return this.$loading({
    lock: true,
    text: text,
    spinner: 'el-icon-loading',
    background: 'rgba(0, 0, 0, 0)'
  })
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js